import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a1a7c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Kurven", -1))
const _hoisted_3 = { class: "productBox layout gutter--xl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_7 = { class: "va-table-responsive checkOutTable" }
const _hoisted_8 = { class: "va-table checkOutTable" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { colspan: "4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Total:", -1))
const _hoisted_23 = { class: "layout gutter--xl" }
const _hoisted_24 = { class: "row justify--center align--center" }
const _hoisted_25 = { class: "flex md6 center linkBox" }
const _hoisted_26 = { class: "flex md6 center checkoutBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_va_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_va_button, {
            size: "small",
            color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.languageValue = 1))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_va_button, {
            size: "small",
            color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageValue = 2))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_9,
              (_ctx.languageValue === 1)
                ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Produkt"))
                : (_openBlock(), _createElementBlock("th", _hoisted_11, "Product")),
              (_ctx.languageValue === 1)
                ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Antal"))
                : (_openBlock(), _createElementBlock("th", _hoisted_13, "Quantity")),
              (_ctx.languageValue === 1)
                ? (_openBlock(), _createElementBlock("th", _hoisted_14, "Pris"))
                : (_openBlock(), _createElementBlock("th", _hoisted_15, "Price"))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.placeInCart
              }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_va_icon, {
                    name: "delete_forever",
                    class: "hoverEffect",
                    color: "danger",
                    onClick: ($event: any) => (_ctx.removeFromCart(item.placeInCart)),
                    style: _normalizeStyle('display: ' + (item.productId === _ctx.competitionRegistrationFeeProductId ? 'none' : 'initial') + ';')
                  }, null, 8, ["onClick", "style"])
                ]),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("i", null, _toDisplayString(item.productDescription), 1)
                ]),
                (!_ctx.canHaveMultipleInCart(item.productId) && item.playerRegistration === null)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                      _createVNode(_component_va_input, {
                        modelValue: item.quantity,
                        "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                        min: "1",
                        type: "number",
                        style: {"width":"50%","text-align":"center"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(item.quantity), 1)),
                _createElementVNode("td", null, _toDisplayString((item.price * item.quantity)) + " kr.", 1)
              ]))
            }), 128)),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_20, [
                _createVNode(_component_va_divider)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_21,
              _createElementVNode("td", null, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.calcTotal()) + " kr.", 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, { to: "/handelsbetingelser" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Handelsbetingelser' : 'Terms & Conditions'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, { to: "/kontakt" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Kontakt' : 'Contact'), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, { to: "/persondataforordning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Persondatapolitik' : 'Privacy Policy'), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_va_button, {
            class: "mr-4",
            rounded: false,
            size: "large",
            color: "danger",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emptyCart()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Tøm' : 'Empty'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_va_button, {
            class: "mr-4",
            rounded: false,
            size: "large",
            color: "secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Tilbage' : 'Go back'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_va_button, {
            class: "ml-4",
            rounded: false,
            size: "large",
            color: "success",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/kassen')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Betal' : 'Go to checkout'), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}